import React from 'react';

import Button        from '@material-ui/core/Button';
import Dialog        from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle   from '@material-ui/core/DialogTitle';
import TextField     from '@material-ui/core/TextField';

export function note(rowid = -1, note = '') {
  return {
    note,
    rowid,
  };
}

export default function NewNote(props) {
  return (
    <Dialog fullWidth open={props.newNote.rowid > -1}>
      <DialogTitle>
        {'비고'}
      </DialogTitle>
      <DialogContent>
        <TextField fullWidth
          multiline rows={4}
          onChange={(event) => { props.setNewNote({...props.newNote, note: event.target.value}); }}
          value={props.newNote.note}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={(event) => { props.setNewNote(props.note()); }}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={(event) => { props.updateNote(); }}>
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}